import { CommonModule, formatDate } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { AuthService } from '../../Service/app-service';
import { SearchPipe } from '../../search-pipe.pipe';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    NgxIntlTelInputModule,
    SearchPipe,
    NgxSpinnerModule,
    NgMultiSelectDropDownModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {
  showPopup = false;
  phoneNumber: any = "";
  selectedCurrency: any = "";
  selectedPlan: any = "";
  noActiveSubscription:boolean = false;
  errorMessage: string | null = null;
  showDetails: boolean = false;
  showSubscription: boolean = true;
  showRingtone: boolean = false;
  showLogs: boolean = false;
  showsmsLogs: boolean = false;
  showuser: boolean = false;
  userInfo = {
    customerId: 'SID 75147',
    number: '263779012735',
    userStatus: 'Active',
    activePlan: 'Monthly',
    registrationPlan: '2021-09-08 14:38:39',
    subscriptionDate: '2021-09-08 14:38:39',
    renewalDate: '2021-09-08 14:38:39',
    lastChargedDate: '2021-09-08 14:38:39',
  };
  transactions = [];
  sms = [];
  user = [];
  searchQuery: string = '';
  searchQuerytrasaction: string = '';
  searchQuerysms: string = '';
  filteredTransactions: any[] = [];
  filteredsms: any[] = [];
  filtereduser: any[] = [];
  paginatedTransactions: any[] = [];
  paginatedsms: any[] = [];
  paginateduser: any[] = [];
  currentPage: number = 1;
  currentPage1: number = 1;
  currentPage2: number = 1;
  rowsPerPage: number = 5;
  rowsPerPage1: number = 5;
  rowsPerPage2: number = 5;
  totalPages: number = 1;
  totalPages1: number = 1;
  totalPages2: number = 1;
  pageSizes: number[] = [5, 10, 20];
  dropdownSettings = {};
  toBeEditedTagId: any;
  genreArray: any;
  statusChangeText: any;
  openConfirmChnagePopup: boolean = false;
  // showContentConfiguration: boolean = false;
  Generes: boolean = false;
  genreForm: any;
  userName: string | null = '';
  userid: any;
  useremail: string = '';
  currentsubscription: any;
  subscriptionId: any;
  changePasswordForm!: FormGroup;
  email: string = '';
  passwordErrorMessage: string = '';
  successMessage: string = '';
  selectedUserId: any;
  rbtIsrc: any;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  sortColumnuser: string = '';
  sortDirectionuser: string = '';
  sortColumnsms: string = '';
  sortDirectionsms: string = '';
  showOldPassword: boolean = false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  constructor(private modalService: NgbModal, private tosterService : ToastrService, private router: Router, private SpinnerService: NgxSpinnerService, private authService: AuthService, private fb: FormBuilder) {
  }
  showSubscriptions(): void {
    this.showSubscription = !this.showSubscription;
  }
  showRington(): void {
    this.showRingtone = !this.showRingtone;
  }
  showTransactionLogs(): void {
    this.showLogs = !this.showLogs;
    this.loadTransactionLogs();
  }

  showUser(): void {
    this.showuser = !this.showuser;
  }

  customer(){
    this.authService.clearPhone();
    window.location.reload();
  }
  getDetails() {
    if (this.phoneNumber.trim()) {
      this.SpinnerService.show();
      this.currentsubscription = []
      this.authService.setPhone(this.phoneNumber);
      this.authService.getPhoneDetails(this.phoneNumber).subscribe(
        (response: any) => {
          if (response && response.statusCode === 200) {
            this.showDetails = true;
            this.currentsubscription = response.data || [];
            this.filtereduser = this.currentsubscription.filter((user:any) => user.subsStatus !== 'Deactivated');
            this.updatePaginationuser();
            this.errorMessage = '';
            const phone = this.currentsubscription[0]?.phone;
            // this.authService.setPhone(phone);

            if (!phone) {
              this.noActiveSubscription = true;
              this.errorMessage = 'Phone number not found in response.';
              this.showDetails = false;
            }
          } else {
            this.noActiveSubscription = false;
            this.errorMessage = 'Failed to fetch details. Please try again.';
            this.showDetails = false;
          }
           this.SpinnerService.hide();
        },
        (error) => {
          // Handle error here
          this.SpinnerService.hide();
          this.noActiveSubscription = false
          this.errorMessage = error.error?.message || 'An error occurred. Please try again later.';
          this.showDetails = false;
        }
      );
    } else {
      this.SpinnerService.hide();
      this.errorMessage = 'Phone number is required';
      this.showDetails = false;
    }
    this.showsmsLogs = false    //changes by naved
    this.showLogs = false      //changes by naved
  }

  getImageUrl(): string {
    return environment.iamge
   }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  // suspendAccount(content: any) {
  //   this.toBeEditedTagId = null
  //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  // }
  openAddForm(content: any) {
    this.SpinnerService.show();
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    this.SpinnerService.hide();
  }
  // openeditRington(content: any) {
  //   this.toBeEditedTagId = null
  //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  // }
  openDeativateRington(content: any, userId: number, toneCode: any) {
    this.selectedUserId = userId;
    this.rbtIsrc = toneCode;
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }
  openblockForm(content: any) {
    this.toBeEditedTagId = null
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
  }
  onCancel() {
    this.modalService.dismissAll();
  }
  ngOnInit(): void {
    this.filteredTransactions = [...this.transactions];
    this.filteredsms = [...this.sms];
    this.filtereduser = [...this.user];
    this.updatePagination();
    this.updatePaginationsms();
    this.updatePaginationuser();
    this.userName = this.authService.getUserName() || 'Guest';
    this.userid = this.authService.getUserid();
    this.useremail = this.authService.getUseremail() || '';
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required,],
      newPassword: ['', [
        Validators.required,
        Validators.pattern('(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}'),
        this.differentFromOldPasswordValidator('oldPassword')
      ]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.mustMatch('newPassword', 'confirmPassword') });

    const storedPhone = this.authService.getPhoneFromStorage();
    if (storedPhone) {
      this.phoneNumber = storedPhone;
      this.getDetails();
    }
  }
  onCancelchange(): void {
    this.changePasswordForm.reset(); // Clear the form
    this.modalService.dismissAll(); // Close the modal
  }

  get oldPassword() {
    return this.changePasswordForm.get('oldPassword');
  }
  get newPassword() {
    return this.changePasswordForm.get('newPassword');
  }

  get confirmPassword() {
    return this.changePasswordForm.get('confirmPassword');
  }

  preventSpace(event: KeyboardEvent): void {
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault();
    }
  }
  differentFromOldPasswordValidator(oldPasswordControlName: string) {
    return (control: any) => {
      const formGroup = control?.parent;
      if (!formGroup) {
        return null;
      }

      const oldPassword = formGroup.get(oldPasswordControlName)?.value;
      const newPassword = control.value;

      if (oldPassword && newPassword === oldPassword) {
        return { sameAsOldPassword: true }; // Custom error
      }

      return null;
    };
  }
  // Custom validator to check if newPassword and confirmPassword match
  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.get(controlName);
      const matchingControl = formGroup.get(matchingControlName);

      if (matchingControl?.errors && !matchingControl.errors['mustMatch']) {
        return;
      }

      if (control?.value !== matchingControl?.value) {
        matchingControl?.setErrors({ mustMatch: true });
      } else {
        matchingControl?.setErrors(null);
      }
    };
  }
  togglePasswordVisibility(field: string) {
    if (field === 'old') {
      this.showOldPassword = !this.showOldPassword;
    } else if (field === 'new') {
      this.showNewPassword = !this.showNewPassword;
    } else if (field === 'confirm') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
  onSubmit(): void {
    console.log("data testing");
    this.SpinnerService.show();
    // Check if the form is valid
    if (this.changePasswordForm.valid) {
      // Extract form values
      const { oldPassword, newPassword, confirmPassword } = this.changePasswordForm.value;

      // Create request body
      const requestBody = {
        oldPassword: oldPassword,
        newPassword: newPassword,
        confirmPassword: confirmPassword
      };

      // Call the changePassword service
      this.email = this.useremail;
      this.authService.changePassword(this.email, requestBody).subscribe({
        next: (response) => {
          console.log('Password change response:', response);
          setTimeout(() => {
            this.clearAuthToken();
            this.modalService.dismissAll();
            this.successMessage = 'Password changed successfully!';
            this.SpinnerService.hide();
            this.tosterService.success(this.successMessage);
            this.router.navigate(['/login']);
          }, 3000);
        },
        error: (error) => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.tosterService.error(error.error.data);
          console.error('Error changing password:', error);
          // this.passwordErrorMessage = 'Current password is incorrect';
        },
      });
    } else {
      this.SpinnerService.hide();
      this.changePasswordForm.markAllAsTouched();
      console.error('Form is invalid. Please check the inputs.');
    }
  }
  clearAuthToken(): void {
    this.logout();
    sessionStorage.removeItem('authToken');
    this.authService.clearPhone();
  }
  getStartIndextransaction(): number {
    return (this.currentPage - 1) * this.rowsPerPage + 1;
  }
  getEndIndextransaction(): number {
    const endIndex = this.currentPage * this.rowsPerPage;
    return endIndex > this.filteredTransactions.length ? this.filteredTransactions.length : endIndex;
  }
  // onRowsPerPageChangetransaction(): void {
  //   this.currentPage = 1;
  //   this.updatePagination(); // Update the paginated data
  // }
  filterTransactions(): void {
    let query = this.searchQuerytrasaction?.toLowerCase() || '';
  
    if (query.startsWith(' ') && query.length > 0) {
      query = query.trimStart();
    }
  
    this.filteredTransactions = this.transactions.filter((transaction) => {
      return Object.entries(transaction).some(([key, value]: [string, any]) => {
        // Check if the key is 'date' and format it for comparison
        if (key === 'date' && value) {
          const formattedDate = formatDate(value, 'dd-MM-yyyy, hh:mm a', 'en-US');
          return formattedDate.toLowerCase().includes(query);
        }
        // Default case for other values
        return value ? value.toString().toLowerCase().includes(query) : false;
      });
    });
  
    this.currentPage = 1;
    this.updatePagination();
  }
  updatePagination(): void {
    this.totalPages = Math.ceil(this.filteredTransactions.length / this.rowsPerPage) || 1;
    this.currentPage = Math.min(this.currentPage, this.totalPages);
    const startIndex = (this.currentPage - 1) * this.rowsPerPage;
    const endIndex = this.currentPage * this.rowsPerPage;
    this.paginatedTransactions = this.filteredTransactions.slice(startIndex, endIndex);
  }

  changePage(page: number): void {
    if (typeof page !== 'number') return;
    this.currentPage = page;
    this.updatePagination();
  }

  getPages() {
    const pages: any[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      if (this.currentPage <= halfMaxPagesToShow + 1) {
        for (let i = 1; i <= maxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      } else if (this.currentPage >= this.totalPages - halfMaxPagesToShow) {
        pages.push(1);
        pages.push('...');
        for (let i = this.totalPages - (maxPagesToShow - 2); i <= this.totalPages; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = this.currentPage - halfMaxPagesToShow + 1; i <= this.currentPage + halfMaxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages);
      }
    }

    return pages;
  }

  isValidPage(page: number | string): page is number {
    return typeof page === 'number';
  }

  sortTable(column: string): void {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.filteredTransactions.sort((a: any, b: any) => {
      const valueA = a[column] || '';
      const valueB = b[column] || '';

      if (valueA < valueB) return this.sortDirection === 'asc' ? -1 : 1;
      if (valueA > valueB) return this.sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

    this.updatePagination();
  }

  getSortIcon(column: string): string {
    if (this.sortColumn === column) {
      return this.sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down';
    }
    return '';
  }
  loadTransactionLogs(): void {
    const subscriptionId = this.currentsubscription[0]?.userId;
    this.transactions =[]
    this.paginatedTransactions = []
    this.authService.getTransactionLogs(subscriptionId).subscribe(
      (response) => {
        this.transactions =[]
        this.filteredTransactions = []
        this.transactions = response.data || [];
        this.filteredTransactions = [...this.transactions];
        this.updatePagination();
      },
      (error) => {
        console.error('Error fetching transaction logs:', error);
      }
    );
  }
  DeactivateAccount(selectedUserId: string, rbtIsrc: any): void {

    this.authService.deactivateUserActiveDevices(selectedUserId, rbtIsrc).subscribe(
      (response) => {
        console.log('User removed successfully:', response);
        this.showToaster();
        setTimeout(() => {
          this.modalService.dismissAll();
          this.getDetails();
        }, 2000);
      },
      (error) => {
        console.error('Error removing account:', error);
      }
    );
  }
  showToaster(): void {
    setTimeout(() => {
      const toast = document.getElementById('deativateToast');
      if (toast) {
        toast.classList.add('show');
        setTimeout(() => {
          toast.classList.remove('show');
        }, 2000);
      } else {
        console.error('Toast element not found!');
      }
    }, 100); // Add a small delay to ensure the DOM updates
  }
  
  showSMSLogs(): void {
    this.showsmsLogs = !this.showsmsLogs;
    this.getSmsLogs();
  }
  getSmsLogs(): void {
    const phoneNumber = this.currentsubscription[0]?.phone;
    console.log("phone", phoneNumber);
    if (phoneNumber) {
      this.sms= []
      this.paginatedsms = []
      this.authService.getsmslogs(phoneNumber).subscribe(
        (response) => {
          this.sms = response.data || [];
          this.filteredsms = [...this.sms];
          this.updatePaginationsms();
        },
        (error) => {
          // this.errorMessage = error.error?.message || 'An error occurred. Please try again later.';
        }
      );
    } else {
      console.error('Phone number not available in the subscription');
    }
  }

  filtersms(): void {
    let query = this.searchQuerysms.toLowerCase();
    if (query.startsWith(' ') && query.length > 0) {
      query = query.trimStart();
    }
    this.filteredsms = this.sms.filter((sms) =>
      {
        return Object.entries(sms).some(([key, value]: [string, any]) => {
          if (key === 'date' && value) {
            const formattedDate = formatDate(value, 'dd-MM-yyyy, hh:mm a', 'en-US');
            return formattedDate.toLowerCase().includes(query);
          }
          return value ? value.toString().toLowerCase().includes(query) : false;
        });
      });

    this.currentPage1 = 1;
    this.updatePaginationsms();
  }

  filteruser(): void {
    let query = this.searchQuery?.toLowerCase() || '';
    if (query.startsWith(' ') && query.length > 0) {
      query = query.trimStart();
    }
  
    this.filtereduser = this.currentsubscription.filter((user: any) =>
      {
        return Object.entries(user).some(([key, value]: [string, any]) => {
          if ((key === 'renewalDate' && value) || (key === 'subscriptionDate' && value)) {
            const formattedDate = formatDate(value, 'dd-MM-yyyy, hh:mm a', 'en-US');
            return formattedDate.toLowerCase().includes(query);
          }
          return value ? value.toString().toLowerCase().includes(query) : false;
        });
      });
    this.currentPage2 = 1;
    this.updatePaginationuser();
  }

  getStartIndexsms(): number {
    return (this.currentPage1 - 1) * this.rowsPerPage1 + 1;
  }
  getEndIndexsms(): number {
    const endIndex = this.currentPage1 * this.rowsPerPage1;
    return endIndex > this.filteredsms.length ? this.filteredsms.length : endIndex;
  }
  updatePaginationsms(): void {
    this.totalPages1 = Math.ceil(this.filteredsms.length / this.rowsPerPage1) || 1;
    this.currentPage1 = Math.min(this.currentPage1, this.totalPages1);
    const startIndex = (this.currentPage1 - 1) * this.rowsPerPage1;
    const endIndex = this.currentPage1 * this.rowsPerPage1;
    this.paginatedsms = this.filteredsms.slice(startIndex, endIndex);
  }

  changePage1(page: number): void {
    if (typeof page !== 'number') return;
    this.currentPage1 = page;
    this.updatePaginationsms();
  }

  getPagessms(){
    const pages:any[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages1 <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages1; i++) {
        pages.push(i);
      }
    } else {
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      if (this.currentPage1 <= halfMaxPagesToShow + 1) {
        for (let i = 1; i <= maxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages1);
      } else if (this.currentPage1 >= this.totalPages1 - halfMaxPagesToShow) {
        pages.push(1);
        pages.push('...');
        for (let i = this.totalPages1 - (maxPagesToShow - 2); i <= this.totalPages1; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = this.currentPage1 - halfMaxPagesToShow + 1; i <= this.currentPage1 + halfMaxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages1);
      }
    }

    return pages;
  }

  sortsms(column: string): void {
    if (this.sortColumnsms === column) {
      this.sortDirectionsms = this.sortDirectionsms === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnsms = column;
      this.sortDirectionsms = 'asc';
    }

    this.filteredsms.sort((a: any, b: any) => {
      const valA = a[column] || '';
      const valB = b[column] || '';

      if (this.sortDirectionsms === 'asc') {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    });

    this.updatePaginationsms();
  }

  getStartIndex(): number {
    return (this.currentPage2 - 1) * this.rowsPerPage2 + 1;
  }
  getEndIndex(): number {
    const endIndex = this.currentPage2 * this.rowsPerPage2;
    return endIndex > this.filtereduser.length ? this.filtereduser.length : endIndex;
  }
  

  updatePaginationuser(): void {
    this.totalPages2 = Math.ceil(this.filtereduser.length / this.rowsPerPage2) || 1;
    this.currentPage2 = Math.min(this.currentPage2, this.totalPages2);
    const startIndex = (this.currentPage2 - 1) * this.rowsPerPage2;
    const endIndex = this.currentPage2 * this.rowsPerPage2;
    this.paginateduser = this.filtereduser.slice(startIndex, endIndex);
  }

  changePage2(page: number): void {
    if (typeof page !== 'number') return;
    this.currentPage2 = page;
    this.updatePaginationuser();
  }

  getPagesuser(){
    const pages:any[] = [];
    const maxPagesToShow = 5;

    if (this.totalPages2 <= maxPagesToShow) {
      for (let i = 1; i <= this.totalPages2; i++) {
        pages.push(i);
      }
    } else {
      const halfMaxPagesToShow = Math.floor(maxPagesToShow / 2);

      if (this.currentPage2 <= halfMaxPagesToShow + 1) {
        for (let i = 1; i <= maxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages2);
      } else if (this.currentPage2 >= this.totalPages2 - halfMaxPagesToShow) {
        pages.push(1);
        pages.push('...');
        for (let i = this.totalPages2 - (maxPagesToShow - 2); i <= this.totalPages2; i++) {
          pages.push(i);
        }
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = this.currentPage2 - halfMaxPagesToShow + 1; i <= this.currentPage2 + halfMaxPagesToShow - 1; i++) {
          pages.push(i);
        }
        pages.push('...');
        pages.push(this.totalPages2);
      }
    }

    return pages;
  }

  sortuser(column: string): void {
    if (this.sortColumnuser === column) {
      this.sortDirectionuser = this.sortDirectionuser === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumnuser = column;
      this.sortDirectionuser = 'asc';
    }

    this.filtereduser.sort((a: any, b: any) => {
      const valA = a[column] || '';
      const valB = b[column] || '';

      if (this.sortDirectionuser === 'asc') {
        return valA > valB ? 1 : valA < valB ? -1 : 0;
      } else {
        return valA < valB ? 1 : valA > valB ? -1 : 0;
      }
    });

    this.updatePaginationuser();
  }
  // openGeneres() {
  //   this.Generes = !this.Generes;
  //   this.showContentConfiguration = false;
  // }
  logout(): void {
    this.SpinnerService.show();
    const token = sessionStorage.getItem('token');

    if (!token) {
      this.tosterService.error('No token found. Please log in again.');
      this.SpinnerService.hide();
      return;
    }
    this.authService.logout(token).subscribe({
      next: (response) => {
        console.log('Logout successful:', response);
        sessionStorage.removeItem('authToken');
        // this.showToast();
        this.tosterService.success('Logout successfully');
        setTimeout(() => {
          this.SpinnerService.hide();
          this.modalService.dismissAll();
          this.router.navigate(['/login']);
        }, 2000);
      },
      error: (error) => {
        this.tosterService.error(error.error.message);
        console.error('Error during logout:', error);
        this.SpinnerService.hide();
        // alert('An error occurred while logging out.');
      },
    });
  }
  // showToast(): void {
  //   const toast = document.getElementById('customToast');
  //   if (toast) {
  //     toast.classList.add('show');
  //     setTimeout(() => {
  //       toast.classList.remove('show');
  //     }, 2000);
  //   }
  // }
  setRingtone() {
    console.log('Set Ringtone button clicked');
    this.router.navigate(['/set-ringtone']);
  }

  search_another(){
    this.noActiveSubscription = false;
    this.errorMessage = '';
    this.phoneNumber = '';
  }

  closePopup() {
    this.selectedCurrency = '';
    this.selectedPlan = '';
    this.SpinnerService.hide();
    this.modalService.dismissAll();
  }

  goToBulkUpload(text:any) {
    this.router.navigate(['/bulk-upload'], {
      queryParams: {
        type: text
      }
    });
  }

  nextStep() {
    this.SpinnerService.show();
    if (!this.selectedCurrency || !this.selectedPlan) return void this.SpinnerService.hide();
    const data = {
      msisdn: this.phoneNumber,
      currency: this.selectedCurrency,
      plan: this.selectedPlan,
      channel: "CCI"
    };
    this.closePopup();
    this.router.navigate(['/set-ringtone'], { state: data });
  }

}